import BaseService, { SLUG_TOKEN } from "../core/BaseService";

export type ComparisonType = 'total' | 'macro' | 'micro';

export default class ClioService extends BaseService {
  static async getProjects(clientSlug: string, page: number, pageSize: number) {
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects?limit=${pageSize}&skip=${pageSize * (page - 1)}`);
  }

  static async getProjectDetails(clientSlug: string, projectId: number, filters: any) {
    const qs = Object.keys(filters||{}).reduce((prev, next) => prev ? `${prev}&${next}=${filters[next]}` : `${next}=${filters[next]}`,  '');
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects/${projectId}?${qs}`);
  }

  static async getProjectFilters(clientSlug: string, projectId: number) {
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects/${projectId}/filters`);
  }

  static async getProjectVisits(clientSlug: string, projectId: number, filters?: any) {
    const qs = Object.keys(filters||{}).reduce((prev, next) => prev ? `${prev}&${next}=${filters[next]}` : `${next}=${filters[next]}`,  '');
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects/${projectId}/visits?${qs}`);
  }

  static async getProjectVisitsStats(clientSlug: string, projectId: number, filters?: any) {
    const qs = Object.keys(filters||{}).reduce((prev, next) => prev ? `${prev}&${next}=${filters[next]}` : `${next}=${filters[next]}`,  '');
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects/${projectId}/visits/stats?${qs}`);
  }

  static async getVisitDetails(clientSlug: string, visitId: number) {
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects/visits/${visitId}`);
  }

  static async downloadVisit(clientSlug: string, visitId: number) {
    return await super.download(`/clients/${clientSlug||SLUG_TOKEN}/projects/visits/${visitId}/pdf`);
  }

  static async getMicroScores(clientSlug: string, projectId: number, filters?: any) {
    const qs = Object.keys(filters||{}).reduce((prev, next) => prev ? `${prev}&${next}=${filters[next]}` : `${next}=${filters[next]}`,  '');
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects/${projectId}/scores/micro?${qs}`);
  }

  static async getMacroScores(clientSlug: string, projectId: number, filters?: any) {
    const qs = Object.keys(filters||{}).reduce((prev, next) => prev ? `${prev}&${next}=${filters[next]}` : `${next}=${filters[next]}`,  '');
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects/${projectId}/scores/macro?${qs}`);
  }

  static async getTotalScore(clientSlug: string, projectId: number, filters?: any) {
    const qs = Object.keys(filters||{}).reduce((prev, next) => prev ? `${prev}&${next}=${filters[next]}` : `${next}=${filters[next]}`,  '');
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects/${projectId}/scores/total?${qs}`);
  }

  static async getComparative(clientSlug: string, projectId: number, type: ComparisonType, filterValue: number, filters?: any) {
    const qs = Object.keys(filters||{}).reduce((prev, next) => prev ? `${prev}&${next}=${filters[next]}` : `${next}=${filters[next]}`,  '');
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects/${projectId}/scores/comparative/${type}/by/${filterValue}?${qs}`);
  }

  static async getTotalScoresCategory(clientSlug: string, categoryId: number, filters?: any) {
    const qs = Object.keys(filters||{}).reduce((prev, next) => prev ? `${prev}&${next}=${filters[next]}` : `${next}=${filters[next]}`,  '');
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects/scores/cat/${categoryId}/summarized?${qs}`);
  }

  static async getMacroScoresCategory(clientSlug: string, categoryId: number, filters?: any) {
    const qs = Object.keys(filters||{}).reduce((prev, next) => prev ? `${prev}&${next}=${filters[next]}` : `${next}=${filters[next]}`,  '');
    return await super.request(`/clients/${clientSlug||SLUG_TOKEN}/projects/scores/cat/${categoryId}/summarized/macros?${qs}`);
  }
}